/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Partner_SubInputs */

const en_cp_partner_sub = /** @type {(inputs: Cp_Partner_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with one pilot class before an MoU. We reply within 2 working days.`)
};

const id_cp_partner_sub = /** @type {(inputs: Cp_Partner_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari satu kelas pilot sebelum MoU. Balasan dalam 2 hari kerja.`)
};

/**
* | output |
* | --- |
* | "Start with one pilot class before an MoU. We reply within 2 working days." |
*
* @param {Cp_Partner_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_partner_sub = /** @type {((inputs?: Cp_Partner_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Partner_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_partner_sub(inputs)
	return en_cp_partner_sub(inputs)
});